import React, { useEffect, useState } from 'react'
import OffConvas from '../../components/OffConvas';
import EquipmentCertificateForm from './components/EquipmentCertificateForm';
import { equipmentCertificateService } from '../../services/equipmentCertificateService';
import { toast } from '../../services/toastService';
import Loading from '../../components/Loading';
import { getStatus } from '../../utils/getStatus ';
import Pagination from '../../components/Pagination';
import DeleteConfirmModal from '../../components/DeleteConfirmModal';


const EquipmentCertificates = () => {

const [data, setData] = useState([]);
  const [id,setId] = useState(0);
  const [deleteId, setDeleteId] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(()=>{
      getAsync();
  },[])
  const getAsync = async (pageNumber=1) => {
   try {
    setLoading(true);
     const res = await equipmentCertificateService.getAll({
      pageNumber: pageNumber,
      pageSize: 15,
      orderBy: "id",
      orderDirection: "desc",
    });
    setData(res.value);
   } catch (error) {
    console.log(error);
   }
   finally{
    setLoading(false);
   }
  };
  const deleteAsync =async ()=>{
    try {
      setLoading(true);
      if(!deleteId) {
        toast.error("Please select a record to delete");
        return;
      }
      var result = await equipmentCertificateService.delete(deleteId);
      if(!result.isSuccess) {
        toast.error(result.errors[0] || "Failed to delete record");
        return;
      }
      toast.success("Record deleted successfully");
      setDeleteId(0);
      if(!search)
      getAsync(data.pageNumber);
    else
      getAllSearchAsync(data.pageNumber);
    } catch (error) {
      toast.error("An error occurred while deleting the record");
    }
    finally{
      setLoading(false);
    }
  }
  const getAllSearchAsync = async (pageNumber=1,signal) => {
    try {
      var res = await equipmentCertificateService.getAllSearchAsync({
      search:search,
      pageNumber:pageNumber,
      pageSize: 15,
      orderBy: "id",
      orderDirection: "desc",
    },signal);
     setData(res.value);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  // 🟢 Search effect with debounce & cancel
  useEffect(() => {
    if (search.trim().length < 2) {
      getAsync(1); // reset to default if search is cleared
      return;
    }

    const controller = new AbortController(); // cancel token
    const delay = setTimeout(() => {
      getAllSearchAsync(1,controller.signal);
    }, 400); // debounce time

    return () => {
      controller.abort(); // cancel previous request
      clearTimeout(delay); // clear debounce
    };
  }, [search]);

  const onPageChange = async (pageNumber) => {
    setLoading(true);
    if (!search) {
      getAsync(pageNumber);
      return;
    }
    await getAllSearchAsync(pageNumber);
  };
{loading && <Loading />}
return (
  <>
    <section className="section-documents">
      <div className="my-card">
        <div className="my-card-header">
          <div className="my-card-title">Equipment Certificates</div>
          <button
            type="button"
            className="my-button my-button-dark"
            data-bs-toggle="offcanvas"
            data-bs-target="#my-equipment-certificate"
          >
            Add New
          </button>
        </div>
        <div className="my-card-body">
          <div className="my-grid">
            <div className="my-grid-header">
              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="form-control my-grid-search"
              />
            </div>
            <div className="my-grid-body">
              <table className="table table-bordered table-responsive">
                <thead>
                  <tr>
                    <th>Certificate No#</th>
                    <th>Sticker No#</th>
                    <th>Equipment Description </th>
                    <th>Equipment Id # </th>
                    <th>Equipment Type </th>
                    <th>Inspection Date </th>
                    <th>Expiry Date </th>
                    <th>Company Name </th>
                    <th>Plate No# </th>
                    <th>Manufacturer </th>
                    <th>Capacity Or SWL </th>
                    <th>Status</th>
                    <th>Remarks </th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.items?.map((item) => {
                    const status = getStatus(
                      item?.inspectionDate,
                      item?.expiryDate,
                    );
                    return (
                      <tr key={item.id}>
                        <td>{item?.certificateNo}</td>
                        <td>{item?.stickerNo}</td>
                        <td>{item?.equipmentDescription}</td>
                        <td>{item?.equipmentSerialIdNo}</td>
                        <td>{item?.equipmentType}</td>
                        <td>{item?.inspectionDate?.toDisplayDate()}</td>
                        <td>{item?.expiryDate?.toDisplayDate()}</td>
                        <td>{item?.companyName}</td>
                        <td>{item?.plateNo}</td>
                        <td>{item?.manufacturer}</td>
                        <td>{item?.capacitySWL}</td>
                        <td>
                          <span className={`badge ${status.className}`}>
                            {status.text}
                          </span>
                        </td>
                        <td>{item?.remarks}</td>
                        <td className="my-grid-actions">
                          <i
                            className="fas fa-pencil text-primary cursor-pointer"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#my-equipment-certificate"
                            onClick={() => setId(item.id)}
                          />
                          <i
                            className="fas fa-trash text-danger cursor-pointer"
                            data-bs-toggle="modal"
                            data-bs-target="#confirm-modal"
                            onClick={() => setDeleteId(item.id)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="my-grid-footer">
              <Pagination
                currentPage={data.pageNumber}
                totalPages={data.totalPages}
                onPageChange={onPageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <DeleteConfirmModal deleteAsync={deleteAsync} />
    <OffConvas
      title="Add New Equipment Certificate"
      id="my-equipment-certificate"
    >
      <EquipmentCertificateForm getAsync={getAsync} id={id} setId={setId} />
    </OffConvas>
  </>
);
}

export default EquipmentCertificates